function mapFilters(filters, defaultFilters = [], callback = () => {}) {
  const restructuredFilters = Object.keys(filters)
    .reduce(setFiltersOrder, defaultFilters)
    .map(callback);
  function setFiltersOrder(acc, field) {
    const filter = filters[field].map(
      fieldFilter => Object.assign(
        {},
        fieldFilter,
        { field },
      )
    );

    return [...acc, ...filter];
  }

  return restructuredFilters;
}

export function createStoredFilters(filters, defaultFilters = []) {
  function restructureFilters({ columnName: field, comparator, value }) {
    return { field, comparator, value };
  }
  
  return mapFilters(filters, defaultFilters, restructureFilters);
}

export function filtersSerializer(filters, defaultFilters = []) {
  function serializeFilters({ columnName, comparator, value }, idx) {
    return [
      `filters[${idx}][field]=${columnName}`,
      `filters[${idx}][comparator]=${comparator}`,
      `filters[${idx}][value]=${encodeURIComponent(value)}`,
    ].join('&')
  }

  return mapFilters(filters, defaultFilters, serializeFilters);
}

export function filtersParser(filters) {
  return filters.reduce(
    (acc, [fieldName, mixedValue]) => {
      const fieldData = acc[fieldName] || [];
      const predicates = deserializePredicates(mixedValue);

      for (let predicate of predicates) {
        fieldData.push(predicate);
      }
      acc[fieldName] = [...fieldData];
      return acc;
    }, {}
  )
};

export function groupFilterOptions(filterOptions) {
  const uniqueFilterOptionLabels = [...new Set(
    filterOptions.map(({ label }) => label)
  )];

  const groupedFilterOptions = uniqueFilterOptionLabels.map(filterOptionLabel => {
    const predicates = filterOptions
    .filter(({ label }) => label === filterOptionLabel)
    .map(({ label, ...predicate }) => predicate);

    const filterOption = {
      label: filterOptionLabel,
      predicates: predicates
    }

    return filterOption;
  });

  return groupedFilterOptions;
}

export function serializeDefaultValue({ optionDefaultValue, type }) {
  let defaultValue = type === 'checkbox' ? [] : '';
  if (!optionDefaultValue || !optionDefaultValue.length) {
    return defaultValue;
  }

  const serialized = serializePredicates(optionDefaultValue);
  if (Array.isArray(defaultValue)) {
    return serialized.split(';');
  }

  return serialized;
}

export function serializePredicates(predicates) {
  return predicates.map(
    ({ columnName, comparator, value }) =>
      Object.values({ columnName, comparator, value }).join('|')
  ).join(';');
}

export function deserializePredicates(serializedPredicates) {
  return serializedPredicates.split(';').map(serializedPredicate => {
    const [columnName, comparator, value = null] = serializedPredicate.split('|');

    return {
      columnName,
      comparator,
      value
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils/FiltersFormatter.js